"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CURRENCY_IDS = void 0;
var CURRENCY_IDS = exports.CURRENCY_IDS = ['MXN', 'USD', 'EUR', 'AED', 'ARS', 'AUD', 'BGN', 'BHD', 'BRL', 'CAD', 'CHF', 'CLP', 'CNY', 'COP', 'CZK', 'DKK', 'GBP', 'HKD', 'HUF', 'IDR', 'ILS', 'INR', 'JPY', 'KRW', 'MYR', 'NOK', 'NZD', 'PEN', 'PHP', 'PLN', 'RON', 'RUB', 'SAR', 'SEK', 'SGD', 'THB', 'TRY', 'TWD', 'ZAR', '---'];